import { Directive, OnInit, Output, EventEmitter, ElementRef } from '@angular/core';
import { CustomComponent } from '@cakeiteasy/web-utils';
import { fromEvent } from "rxjs";
import { delay, tap } from "rxjs/operators";

@Directive({
  standalone: false,
  selector: '[clickOutside]'
})

export class ClickOutsideDirective extends CustomComponent implements OnInit {
  private listening: boolean = false;

  @Output() clickOutside = new EventEmitter<Object>();

  constructor(private _elRef: ElementRef) {
    super();
  }

  ngOnInit() {
    this._subscribe();
  }

  private _subscribe() {
    this.addSubscriber(fromEvent(document, 'click')
      .pipe(
        delay(1),
        tap(() => {
          this.listening = true;
        }))
      .subscribe((event: MouseEvent) => {
        this.onGlobalClick(event);
      }));
  }

  private onGlobalClick(event: MouseEvent) {
    if (event instanceof MouseEvent && this.listening === true) {
      if (this._isDescendant(this._elRef.nativeElement, event.target) === true) {
        this.clickOutside.emit({
          target: (event.target || null),
          value: false
        });
      } else {
        this.clickOutside.emit({
          target: (event.target || null),
          value: true
        });
      }
    }
  }

  private _isDescendant(parent, child) {
    let node = child;
    while (node !== null) {
      if (node === parent) {
        return true;
      } else {
        node = node.parentNode;
      }
    }
    return false;
  }
}
